"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isNegative = function (num) {
    return is_number_1.default(num) && num < 0;
};
exports.default = isNegative;
//# sourceMappingURL=is-negative.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-negative.js
// module id = 1121
// module chunks = 37